function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
//// CONTROLLER ////
export var distributedAssetsSearch = {
  selector: 'distributedAssetsSearch',
  bindings: {},
  template: require('./distributedAssetsSearch-template.html'),
  controller:
  /*#__PURE__*/
  function () {
    _createClass(DistributedAssetsSearchController, null, [{
      key: "$inject",
      get: function get() {
        return ['$state', '$stateParams', '$q', '$rootScope', '$scope', 'addelivery.event.constants', 'AdvertiserResourceFactory', 'CampaignsResourceFactory', 'DestinationResourceFactory', '$mdPanel', '$timeout', 'EnumService', 'loginService'];
      }
    }]);

    function DistributedAssetsSearchController($state, $stateParams, $q, $rootScope, $scope, EventConstants, AdvertiserResourceFactory, CampaignsResourceFactory, DestinationResourceFactory, $mdPanel, $timeout, EnumService, loginService) {
      _classCallCheck(this, DistributedAssetsSearchController);

      /* BINDABLE : INJECTS */
      Object.assign(this, {
        $state: $state,
        $stateParams: $stateParams,
        $q: $q,
        $rootScope: $rootScope,
        $scope: $scope,
        EventConstants: EventConstants,
        AdvertiserResourceFactory: AdvertiserResourceFactory,
        CampaignsResourceFactory: CampaignsResourceFactory,
        DestinationResourceFactory: DestinationResourceFactory,
        $mdPanel: $mdPanel,
        $timeout: $timeout,
        EnumService: EnumService,
        loginService: loginService
      });
      var vm = this;
      /* BINDABLE : DATA */

      vm.searchParams = {};
      vm.formats = [];
      vm.advertisers = [];
      vm.destinationReceivers = [];
      /* EVENTS */
      //Register any event listeners
    }
    /* IMPLEMENTATION : BINDABLE */


    _createClass(DistributedAssetsSearchController, [{
      key: "search",
      value: function search() {
        var vm = this;
        this.$state.go('distributedAssetsList', vm.searchParams, {
          notify: true,
          inherit: false,
          reload: true
        });
      }
    }, {
      key: "clear",
      value: function clear() {
        var vm = this;
        vm.searchParams = {};
        vm.orderDateSearchText = '';
        vm.startDateSearchText = '';
        vm.endDateSearchText = '';
      }
    }, {
      key: "showOrderDate",
      value: function showOrderDate() {
        var vm = this;
        var position = vm.$mdPanel.newPanelPosition().relativeTo('.order-date-input').addPanelPosition(vm.$mdPanel.xPosition.OFFSET_END, vm.$mdPanel.yPosition.CENTER);
        var orderDatePanel = {
          attachTo: angular.element(document.body),
          controller: function controller() {},
          controllerAs: 'ctrl',
          disableParentScroll: true,
          template: require('./orderDatePanel-template.html'),
          scope: vm.$scope,
          preserveScope: true,
          panelClass: 'search-popover-panel',
          position: position,
          clickOutsideToClose: true,
          escapeToClose: true,
          focusOnOpen: true,
          zIndex: 2,
          onRemoving: function onRemoving(event, removePromise) {
            vm._setOrderDateSearchText();
          }
        };
        vm.$mdPanel.open(orderDatePanel);
      }
    }, {
      key: "showStartDate",
      value: function showStartDate() {
        var vm = this;
        var position = vm.$mdPanel.newPanelPosition().relativeTo('#startDate_distributedassetssearch_input').addPanelPosition(vm.$mdPanel.xPosition.OFFSET_END, vm.$mdPanel.yPosition.CENTER);
        var startDatePanel = {
          attachTo: angular.element(document.body),
          controller: function controller() {},
          controllerAs: 'ctrl',
          disableParentScroll: true,
          template: require('./startDatePanel-template.html'),
          scope: vm.$scope,
          preserveScope: true,
          panelClass: 'search-popover-panel',
          position: position,
          clickOutsideToClose: true,
          escapeToClose: true,
          focusOnOpen: true,
          zIndex: 2,
          onRemoving: function onRemoving(event, removePromise) {
            vm._setStartDateSearchText();
          }
        };
        vm.$mdPanel.open(startDatePanel);
      }
    }, {
      key: "showEndDate",
      value: function showEndDate() {
        var vm = this;
        var position = vm.$mdPanel.newPanelPosition().relativeTo('#endDate_distributedassetssearch_input').addPanelPosition(vm.$mdPanel.xPosition.OFFSET_END, vm.$mdPanel.yPosition.CENTER);
        var endDatePanel = {
          attachTo: angular.element(document.body),
          controller: function controller() {},
          controllerAs: 'ctrl',
          disableParentScroll: true,
          template: require('./endDatePanel-template.html'),
          scope: vm.$scope,
          preserveScope: true,
          panelClass: 'search-popover-panel',
          position: position,
          clickOutsideToClose: true,
          escapeToClose: true,
          focusOnOpen: true,
          zIndex: 2,
          onRemoving: function onRemoving(event, removePromise) {
            vm._setEndDateSearchText();
          }
        };
        vm.$mdPanel.open(endDatePanel);
      }
    }, {
      key: "checkOrderDate",
      value: function checkOrderDate() {
        var vm = this;

        if (!vm.orderDateSearchText) {
          vm.searchParams.orderDateFrom = null;
          vm.searchParams.orderDateTo = null;
          vm.searchParams.orderDate = null;
        } else if (!vm.searchParams.orderDateFrom) {
          vm.searchParams.orderDateFrom = null;
        } else if (!vm.searchParams.orderDateTo) {
          vm.searchParams.orderDateTo = null;
        }
      }
    }, {
      key: "checkStartDate",
      value: function checkStartDate() {
        var vm = this;

        if (!vm.startDateSearchText) {
          vm.searchParams.startDateFrom = null;
          vm.searchParams.startDateTo = null;
          vm.searchParams.startDate = null;
        } else if (!vm.searchParams.startDateFrom) {
          vm.searchParams.startDateFrom = null;
        } else if (!vm.searchParams.startDateTo) {
          vm.searchParams.startDateTo = null;
        }
      }
    }, {
      key: "checkEndDate",
      value: function checkEndDate() {
        var vm = this;

        if (!vm.endDateSearchText) {
          vm.searchParams.endDateFrom = null;
          vm.searchParams.endDateTo = null;
          vm.searchParams.endDate = null;
        } else if (!vm.searchParams.endDateFrom) {
          vm.searchParams.endDateFrom = null;
        } else if (!vm.searchParams.endDateTo) {
          vm.searchParams.endDateTo = null;
        }
      }
    }, {
      key: "loadAdvertisers",
      value: function loadAdvertisers() {
        var vm = this;
        var advertiserPromise = vm.$q.defer();
        vm.AdvertiserResourceFactory.getAll({
          providerAccountId: vm.loginService.getSessionData().accountId,
          active: true
        }).subscribe(function (advertisers) {
          vm.advertisers = vm._removeDuplicates(advertisers, 'name');
          advertiserPromise.resolve(vm.advertisers);
        }, function (err) {
          advertiserPromise.resolve([]);
          console.debug(err);
        });
        return advertiserPromise;
      }
    }, {
      key: "loadCampaigns",
      value: function loadCampaigns() {
        var vm = this;
        var campaignPromise = vm.$q.defer();
        vm.CampaignsResourceFactory.getAll({
          accountId: vm.loginService.getSessionData().accountId
        }, function success(campaigns) {
          vm.campaigns = vm._removeDuplicates(campaigns.data, 'name');
          campaignPromise.resolve(vm.campaigns);
        }, function failure(err) {
          campaignPromise.resolve([]);
          console.debug(err);
        });
        return campaignPromise;
      }
    }, {
      key: "loadDestinations",
      value: function loadDestinations() {
        var vm = this;
        var destinationPromise = vm.$q.defer();
        vm.DestinationResourceFactory.getAllGranted({}, function success(destinationReceivers) {
          vm.destinationReceivers = destinationReceivers.data;
          destinationPromise.resolve(vm.destinationReceivers);
        }, function failure(err) {
          destinationPromise.resolve([]);
          console.debug(err);
        });
        return destinationPromise;
      }
      /* IMPLEMENTATION : PRIVATE */

    }, {
      key: "_setOrderDateSearchText",
      value: function _setOrderDateSearchText() {
        var vm = this;
        var returnText = '';

        if (!vm.searchParams.orderDateFrom && !!vm.searchParams.orderDateTo) {
          returnText = 'before ' + moment(vm.searchParams.orderDateTo).format('MM/DD/YYYY');
          vm.searchParams.orderDate = 'lte:' + moment(new Date(vm.searchParams.orderDateTo)).hour(23).minute(59).second(59).format('MM-DD-YYYY h:mm:ss a');
        } else if (!!vm.searchParams.orderDateFrom && !vm.searchParams.orderDateTo) {
          returnText = 'after ' + moment(vm.searchParams.orderDateFrom).format('MM/DD/YYYY');
          vm.searchParams.orderDate = 'gte:' + moment(new Date(vm.searchParams.orderDateFrom)).hour(0).minute(0).second(0).format('MM-DD-YYYY h:mm:ss a'); // If it has both dates
        } else if (!!vm.searchParams.orderDateFrom && !!vm.searchParams.orderDateTo) {
          returnText = moment(vm.searchParams.orderDateFrom).format('MM/DD/YYYY') + ' to ' + moment(vm.searchParams.orderDateTo).format('MM/DD/YYYY');
          vm.searchParams.orderDate = 'bt:[' + moment(new Date(vm.searchParams.orderDateFrom)).hour(0).minute(0).second(0).format('MM-DD-YYYY h:mm:ss a') + ',' + moment(new Date(vm.searchParams.orderDateTo)).hour(23).minute(59).second(59).format('MM-DD-YYYY h:mm:ss a') + ']';
        }

        vm.orderDateSearchText = returnText;
      }
    }, {
      key: "_setStartDateSearchText",
      value: function _setStartDateSearchText() {
        var vm = this;
        var returnText = '';

        if (!vm.searchParams.startDateFrom && !!vm.searchParams.startDateTo) {
          returnText = 'before ' + moment(vm.searchParams.startDateTo).format('MM/DD/YYYY');
          vm.searchParams.startDate = 'lte:' + moment(new Date(vm.searchParams.startDateTo)).hour(23).minute(59).second(59).format('MM-DD-YYYY h:mm:ss a');
        } else if (!!vm.searchParams.startDateFrom && !vm.searchParams.startDateTo) {
          returnText = 'after ' + moment(vm.searchParams.startDateFrom).format('MM/DD/YYYY');
          vm.searchParams.startDate = 'gte:' + moment(new Date(vm.searchParams.startDateFrom)).hour(0).minute(0).second(0).format('MM-DD-YYYY h:mm:ss a'); // If it has both dates
        } else if (!!vm.searchParams.startDateFrom && !!vm.searchParams.startDateTo) {
          returnText = moment(vm.searchParams.startDateFrom).format('MM/DD/YYYY') + ' to ' + moment(vm.searchParams.startDateTo).format('MM/DD/YYYY');
          vm.searchParams.startDate = 'bt:[' + moment(new Date(vm.searchParams.startDateFrom)).hour(0).minute(0).second(0).format('MM-DD-YYYY h:mm:ss a') + ',' + moment(new Date(vm.searchParams.startDateTo)).hour(23).minute(59).second(59).format('MM-DD-YYYY h:mm:ss a') + ']';
        }

        vm.startDateSearchText = returnText;
      }
    }, {
      key: "_setEndDateSearchText",
      value: function _setEndDateSearchText() {
        var vm = this;
        var returnText = '';

        if (!vm.searchParams.endDateFrom && !!vm.searchParams.endDateTo) {
          returnText = 'before ' + moment(vm.searchParams.endDateTo).format('MM/DD/YYYY');
          vm.searchParams.endDate = 'lte:' + moment(new Date(vm.searchParams.endDateTo)).hour(23).minute(59).second(59).format('MM-DD-YYYY h:mm:ss a');
        } else if (!!vm.searchParams.endDateFrom && !vm.searchParams.endDateTo) {
          returnText = 'after ' + moment(vm.searchParams.endDateFrom).format('MM/DD/YYYY');
          vm.searchParams.endDate = 'gte:' + moment(new Date(vm.searchParams.endDateFrom)).hour(0).minute(0).second(0).format('MM-DD-YYYY h:mm:ss a'); // If it has both dates
        } else if (!!vm.searchParams.endDateFrom && !!vm.searchParams.endDateTo) {
          returnText = moment(vm.searchParams.endDateFrom).format('MM/DD/YYYY') + ' to ' + moment(vm.searchParams.endDateTo).format('MM/DD/YYYY');
          vm.searchParams.endDate = 'bt:[' + moment(new Date(vm.searchParams.endDateFrom)).hour(0).minute(0).second(0).format('MM-DD-YYYY h:mm:ss a') + ',' + moment(new Date(vm.searchParams.endDateTo)).hour(23).minute(59).second(59).format('MM-DD-YYYY h:mm:ss a') + ']';
        }

        vm.endDateSearchText = returnText;
      }
    }, {
      key: "_removeDuplicates",
      value: function _removeDuplicates(objList, prop) {
        return objList.filter(function (obj, pos, arr) {
          return arr.map(function (mapObj) {
            return mapObj[prop];
          }).indexOf(obj[prop]) === pos;
        });
      }
      /* INITIALIZATION */

    }, {
      key: "$onInit",
      value: function $onInit() {
        var vm = this;
        vm.searchParams = vm.$stateParams;
        vm.searchParams.includeArchives = vm.searchParams.includeArchives === 'true';
        this.EnumService.getEnum('Spot', 'format').then(function (formats) {
          vm.formats = formats;
        }, function () {
          vm.formats = [];
        });
        vm.loadAdvertisers();
        vm.loadCampaigns();
        vm.loadDestinations();

        vm._setOrderDateSearchText();

        vm._setStartDateSearchText();

        vm._setEndDateSearchText();
      }
    }]);

    return DistributedAssetsSearchController;
  }(),
  controllerAs: 'vm'
};